document.querySelectorAll('[data-tabs]').forEach(tabsHolder => {

  const tablist = tabsHolder.querySelector('[role="tablist"]');
  const tabs = tablist.querySelectorAll('[role="tab"]');
  const panels = tabsHolder.querySelectorAll('[role="tabpanel"]');

  //console.log('Tabs initialized', tabsHolder, tabs, panels, tablist);

// Arrow key navigation
  tablist.addEventListener('keydown', (e) => {
    const currentTab = e.target;
    const currentIndex = Array.from(tabs).indexOf(currentTab);
    let newIndex;

    if (e.key === 'ArrowRight') {
      newIndex = (currentIndex + 1) % tabs.length;
    } else if (e.key === 'ArrowLeft') {
      newIndex = (currentIndex - 1 + tabs.length) % tabs.length;
    } else if (e.key === 'Home') {
      newIndex = 0;
    } else if (e.key === 'End') {
      newIndex = tabs.length - 1;
    } else {
      return;
    }

    e.preventDefault();
    activateTab(tabs[newIndex]);
  });

// Click handling
  tabs.forEach(tab => {
    tab.addEventListener('click', () => activateTab(tab));
  });

  function activateTab(newTab) {
    // Deactivate all tabs
    tabs.forEach(tab => {
      tab.setAttribute('aria-selected', 'false');
      tab.setAttribute('tabindex', '-1');
    });

    // Hide all panels
    panels.forEach(panel => {
      panel.hidden = true;
    });

    // Activate new tab
    newTab.setAttribute('aria-selected', 'true');
    newTab.removeAttribute('tabindex');
    newTab.focus();

    // Show corresponding panel
    const panelId = newTab.getAttribute('aria-controls');
    document.getElementById(panelId).hidden = false;
  }

});
